export default __webpack_public_path__ + "static/progress1-297dc6784f55a8b1280413e36efd2ab0.mp4";